module.exports = __webpack_public_path__ + "static/media/Icon-Docu.1eb22afc.png";